import gql from "graphql-tag";
import { jobDetailsFields } from "../queries/getJob";

export const UPDATE_JOB = gql`mutation updateJob($id: ID!, $updateJobInput: UpdateJobInput!) {
    updateJob(id: $id, updateJobInput: $updateJobInput) {
        ${jobDetailsFields}
    }
}`;
